import React from 'react';
import PropTypes from 'prop-types';
import FormInputHOC from './FormInputHOC';
import debounce from 'lodash/debounce';

const TextInput = props => {
  const handleChange = e => {
    const value = e.target.value.trim();
    props.onChange(props.name,
      value);
    if (props.validate) {
      props.validate({ [props.name]: value });
    }
  };

  const getProps = () => {
    /* eslint-disable no-unused-vars */
    const {
      onChange,
      validate,
      value,
      inputName,
      selectName,
      reference,
      options,
      customer,
      selectValue,
      onChangeCode,
      dialCode,
      showError,
      interactCustomerInfo,
      debounceValue,
      ...properties
    } = props;
    /* eslint-enable no-unused-vars */
    if (!properties.hasOwnProperty('id')) {
      properties.id = properties.name;
    }
    properties.onChange = debounce(handleChange, debounceValue ?? 200);
    properties.defaultValue = value;
    return properties;
  };

  return <input {...getProps()} />;
};

TextInput.defaultProps = {
  type: 'text',
  value: '',
};

TextInput.PropTypes = {
  type:PropTypes.string,
  name:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  onPaste:PropTypes.func,
  validate:PropTypes.func,
  value:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
  interactCustomerInfo:PropTypes.func,
  reference:PropTypes.func,
  onChangeCode:PropTypes.func,
  inputName:PropTypes.string,
  selectName:PropTypes.string,
  options:PropTypes.array,
  customer:PropTypes.object,
  selectValue:PropTypes.string,
  dialCode:PropTypes.string,
  showError:PropTypes.bool,
};

export default FormInputHOC(TextInput);
